import React from "react";
import { X } from "lucide-react";

export function Modal({ open, onClose, icon: Icon, iconClass = "", title, subtitle, children, footer, wide = false, widest = false, tall = false, headerActions }) {
  if (!open) return null;
  return (
    <div className="modal-bg" onClick={onClose} data-testid="modal-overlay">
      <div className={`modal${widest ? " modal-widest" : wide ? " modal-wide" : ""}${tall ? " modal-tall" : ""}`} onClick={(e) => e.stopPropagation()}
        role="dialog" aria-modal="true" aria-label={typeof title === "string" ? title : undefined}>
        <div className="modal-h">
          {Icon && <div className="mi" style={iconClass ? {} : {}}>{<Icon size={20} />}</div>}
          <div style={{ flex: 1 }}>
            <div className="head" style={{ fontSize: 17, fontWeight: 700 }}>{title}</div>
            {subtitle && <div style={{ fontSize: 12.5, color: "var(--text-2)" }}>{subtitle}</div>}
          </div>
          {headerActions && <div style={{ display: "inline-flex", gap: 6, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>{headerActions}</div>}
          <button className="icon-btn" onClick={onClose} data-testid="modal-close"><X size={18} /></button>
        </div>
        <div className="modal-b">{children}</div>
        {footer && <div className="modal-f">{footer}</div>}
      </div>
    </div>
  );
}
